import { createFileRoute } from '@tanstack/react-router'

import { AccessScreen } from '../components/access-screen.tsx'

export const Route = createFileRoute('/access')({
  component: AccessScreen
})
